import React, { useState } from "react";
import './SearchBox.scss'
import anime from 'animejs'

import classNames from 'classnames'
import {CSSTransition} from "react-transition-group";
import { Button } from './Buttons'
import Slider from './Slider'
import { ButtonGroup, ButtonGroupLimit, RadioButton } from './Buttons'

class SearchBox extends React.Component {
  constructor(props) {
    super(props)

  }
  handleChange_multi({ key, index, value }) {
    this.props.onChange({ key, index, value })
  }
  async handleChange_finish({ key, index, value }) {
    await this.props.onChange({ key, index, value })
  }
  handleChange_excl({ key, value }) {
    this.props.onChange({ key, value })
  }
  reset() {
    this.props.onReset()
  }
  toggleType() {
    this.props.onToggleType()
  }
  scrollIfHidden() {
    const buttonheight_offset = 120
    const btn = document.getElementById('detail')

    if(!btn || !this.props.showResultButton || btn.classList.contains('is-animate')) return

    const is_type_button_hidden = document.scrollingElement.scrollTop < btn.offsetTop - window.innerHeight + buttonheight_offset
    if(is_type_button_hidden) {
      
      // 画面スクロール
      anime({
        targets: { scroll: window.document.scrollingElement },
        scroll: [document.scrollingElement.scrollTop, btn.offsetTop],
        duration: 1000,
        easing: 'easeInQuart',
        update: (a) => {
          document.scrollingElement.scrollTop = a.animations[0].currentValue;
        },
        complete: e => {
          console.log('ascrolled')
          btn.classList.add('is-animate')
        }
      });


      // sp検索ボックス内のスクロール
      const searchbox = document.getElementById('searchbox')
      anime({
        targets: { scroll: searchbox },
        scroll: [searchbox.scrollTop, searchbox.scrollHeight],
        duration: 800,
        easing: 'easeInQuart',
        update: (a) => {
          searchbox.scrollTop = a.animations[0].currentValue
        },
      })

    } else {
      btn.classList.add('is-animate')
    }
  }
  render() {



    return (
      <div id="searchbox">
        <h2>{this.props.settings.quality.title}</h2>
        <RadioButton
          label="quality"
          onChange={({ key, value }) => {
            this.handleChange_excl({ key, value })
          }}
          value={this.props.cond.quality}
          caption={this.props.settings.quality.title}
          options={this.props.settings.quality.data}
        />

        <h2 dangerouslySetInnerHTML={{ __html: this.props.settings.damage.title }}></h2>
        <ButtonGroup
          label="damage"
          col="2"
          onChange={({ key, index, value }) => {
            this.handleChange_multi({ key, index, value })
          }}
          value={this.props.cond.damage}
          caption={this.props.settings.damage.title}
          options={this.props.settings.damage.data}
        />

        <h2 dangerouslySetInnerHTML={{ __html: this.props.settings.finish.title }}></h2>
        <ButtonGroupLimit
          label="finish"
          col="3"
          onChange={({ key, index, value }) => {
            this.handleChange_finish({ key, index, value })
          }}
          value={this.props.cond.finish}
          caption={this.props.settings.finish.title}
          options={this.props.settings.finish.data}
        />

        <h2>{this.props.settings.preference.title}</h2>
        <Slider
          onChange={value => {
            this.handleChange_excl({ key: 'preference', value: value })
          }}
          caption={this.props.settings.preference.title}
          min={this.props.settings.preference.min}
          max={this.props.settings.preference.max}
          value={this.props.cond.preference}
          label={this.props.settings.preference.label}
        />

        <h2>{this.props.settings.scalp.title}</h2>
        <RadioButton
          label="scalp"
          col="3"
          onChange={({ key, value }) => {
            this.handleChange_excl({ key, value })
          }}
          value={this.props.cond.scalp}
          caption={this.props.settings.scalp.title}
          options={this.props.settings.scalp.data}
        />
        {/* <div id="detail" className={classNames({'anim--blink': true,})}>
          <CSSTransition
            classNames="modal"
            in={this.props.showResultButton}
            timeout={1200}
            unmountOnExit
            onEntered={this.scrollIfHidden()}
          >
            <div className="anim__shadow">
              <Button
                addClass="show_type"
                onClick={e => {
                  this.toggleType()
                }}
              >
                結果を詳しく見る
              </Button>
            </div>
          </CSSTransition>
        </div> */}
      </div>
    )
  }
}

export default SearchBox
